module.exports = "/assets/data/1f64e95c62bb4cff108e8e135f40cfea-IP18.data.json";